import { render, staticRenderFns } from "./logo-upload.vue?vue&type=template&id=bbbba62c&shadow"
import script from "./logo-upload.vue?vue&type=script&lang=ts&shadow"
export * from "./logo-upload.vue?vue&type=script&lang=ts&shadow"
function injectStyles (context) {
  
  var style0 = require("./logo-upload.vue?vue&type=style&index=0&id=bbbba62c&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports